import { Component, EventEmitter, Input, OnInit, Output, SimpleChange, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { NzTreeSelectComponent } from 'ng-zorro-antd/tree-select';
import { CustomValidatorService } from '../../../../service/custom-validator.service';
import { JobLevelState } from '../../../../store/jobLevel/job-level-state';
import { JobStatusState } from '../../../../store/jobStatus/job-status-state';
import { JobTypeState } from '../../../../store/jobType/job-type-state';
import { NzMessageService } from 'ng-zorro-antd/message';
import { JobService } from '../../../../service/job.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { KnowledgeService } from '../../../../service/knowledge.service';
import { JobLocationState } from '../../../../store/jobLocation/job-location-state';
import { EquipmentService } from '../../../../service/equipment.service';
import * as moment from 'moment';
import { PatrolSheetService } from '../../../../service/patrol-sheet.service';
import { JobPatrolSheetComponent } from './job-patrol-sheet/job-patrol-sheet.component';
import { PatrolAreaService } from '../../../../service/patrol-area.service';
import { KnowledgeDetailComponent } from '../../../../knowledge/knowledge-manager/knowledge-detail/knowledge-detail.component';

@Component({
  selector: 'app-job-detail-header',
  templateUrl: './job-detail-header.component.html',
  styleUrls: ['./job-detail-header.component.less']
})
export class JobDetailHeaderComponent implements OnInit {

  @Output() nzTypeChangedVote = new EventEmitter<any>();
  @Output() nzThirdServiceChangedVote = new EventEmitter<any>();
  @Input() job: any;
  @Input() code: number; // code 0 详情 1 编辑 2 处置 3 历史详情，与详情的区别是只显示工单内容，不再显示查看知识库、备件库等功能
  @ViewChild('typeTreeSelect') typeTreeSelect: NzTreeSelectComponent;
  validateForm: FormGroup = null;
  stepList: { name: string, id: number }[] = [];
  repairApplyType = null;
  jobLevels = [];
  jobStatus = [];
  jobTypes = [];
  jobLocations = [];
  value?: string;
  beforeValue = '';
  currentStep = 1;
  epName = ''; // 资产名称
  typeMap = new Map<number, any>();
  knowledgeTypes = [];
  kList = [];
  // faultFileList = [
  // ];
  // beforeFileList = [
  // ];
  // completedFileList = [
  // ];
  showUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: false,
    hidePreviewIconInNonImage: true
  };
  equipments = [];
  listOfOption: Array<{ value: string; text: string }> = [];
  groups = [];
  // 业务类型提示框
  typeTooltip = '请选择';
  nzFilterOption = () => true;
  constructor(
    private fb: FormBuilder,
    private store: Store,
    private customValidatorService: CustomValidatorService,
    private msg: NzMessageService,
    private modal: NzModalService,
    private dataService: KnowledgeService,
    private jobService: JobService,
    private areaService: PatrolAreaService,
    private equipmentService: EquipmentService,
    private patrolSheetService: PatrolSheetService,
    private modalService: NzModalService) { }

  async ngOnInit() {
    // 查询固定资产组
    this.patrolSheetService.getPatrolSheetsByJobId(this.job.jno).subscribe((data) => {
      if (!this.isEmpty(data)) {
        data.forEach((item) => {
          this.groups.push(JSON.parse(item.sheetContent));
        });
      }
    });

    this.validateForm = this.fb.group({
      jno: [null, [Validators.required]], // 工单编号
      jtNo: [null, [Validators.required]], // 工单业务类型
      jlNo: [null, [Validators.required]], // 工单优先级别
      // status: [null], // 工单当前状态
      location: [null, [Validators.required]], // 故障位置
      callerName: [null], // 报修人姓名
      callerPhone: [null, [Validators.required, this.customValidatorService.tellPhoneNumberValidator]], // 报修人电话
      hourEstimation: [null], // 预估工时
      estimatedCompletedTime: [null], // 要求完成时间
      mark: [null], // 备注信息
      verifyDesc: [null],
      completedRecord: [null],
      faultUri: [null], // 报修图片上传
      completedUri: [null],  // 完成图片上传
      isEquipment: false, // 是否为固定资产
      epNo: [null], // 资产编号
      epName: '', // 资产名称
      isThirdServices: false,
      isAccidentShutdown: false,
      hourCompleted: [null],
      pno: [null],
      taskName: [null],
      deviceType: ['other']
    });
    // await this.initFileList();
    await this.initTypeData();
    this.jobLevels = this.store.selectSnapshot<any[]>(JobLevelState);
    this.jobStatus = this.store.selectSnapshot<any[]>(JobStatusState);
    this.jobTypes = this.initTypeTree(this.store.selectSnapshot<any[]>(JobTypeState));
    this.jobLocations = this.initLocations(this.store.selectSnapshot<any[]>(JobLocationState));
    // 初始化步骤条
    this.setStepList();
    // 初始化表单
    this.setFormData(this.job);
    // tslint:disable-next-line:radix
    this.currentStep = parseInt(this.job.status) - 1;
  }
  // tslint:disable-next-line:use-lifecycle-interface
  ngOnChanges(changes: SimpleChange) {
    // tslint:disable-next-line:no-string-literal
    if (changes['job']) {
      // 当工单发生改变，重新赋值表单数据
      if (this.validateForm != null) {
        this.setFormData(this.job);
        // tslint:disable-next-line:radix
        this.currentStep = parseInt(this.job.status) - 1;
      }
    }
  }
  initTypeTree(types: any[]) {
    const jobTypes = [];
    const typeMap = new Map<number, any>();
    for (const type of types) {
      const node = {
        title: type.skillName,
        value: type.skillId,
        key: type.skillId,
        isLeaf: true
      };
      if (type.parentId === 0) {
        jobTypes.push(node);
      } else {
        const parent = this.typeMap.get(type.parentId);
        if (parent != null) {
          if (parent.children == null) {
            parent.children = [];
            parent.isLeaf = false;
          }
          parent.children.push(node);
        }
      }
      this.typeMap.set(type.skillId, node);
    }
    return jobTypes;
  }
  initLocations(locations: any[]) {
    const locationList = [];
    const locationMap = new Map<any, any>();
    for (const location of locations) {
      const node = {
        title: location.locationName,
        value: location.locationId,
        key: location.locationName,
        isLeaf: true
      };
      if (locationMap.has(location.parentId)) {
        const parent = locationMap.get(location.parentId);
        if (parent.children == null) {
          parent.children = [];
          parent.isLeaf = false;
        }
        parent.children.push(node);
      } else {
        locationList.push(node);
      }
      locationMap.set(location.locationId, node);
    }
    return locationList;
  }
  treeSelectChanged(key) {
    this.fillTypeTooltip(key);
    if (!this.isEmpty(key)) {
      const node = this.typeTreeSelect.getTreeNodeByKey(key);
      if (node != null) {
        if (node.isLeaf) {
          this.beforeValue = key;
          this.nzTypeChangedVote.emit(key);
        } else {
          this.validateForm.get('jtNo').setValue(this.beforeValue);
        }
      }
    }
  }
  fillTypeTooltip(key) {
    if (key !== undefined && key !== null) {
      if (this.typeTreeSelect) {
        let currentNode = this.typeTreeSelect.getTreeNodeByKey(key);
        if (currentNode != null) {
          // 获取叶子节点完整路径，用于提示框
          let toolTip = `${currentNode.origin.title}`;
          while (currentNode.getParentNode()) {
            currentNode = currentNode.getParentNode();
            toolTip = `${currentNode.origin.title}-->${toolTip}`;
          }
          this.typeTooltip = toolTip;
        }
      }
    }
  }
  locationtreeSelectChanged(key) {

  }
  public setStepList() {
    this.jobStatus.forEach((item) => {
      this.stepList.push({ name: item.dictLabel, id: item.dictValue });
    });
  }
  public setFaultFileList(list) {
    // switch (list[0].status) {
    //   case 'removed':
    //     this.faultFileList.pop();
    //     break;
    //   case 'done':
    //     this.faultFileList = list;
    //     break;
    //   default:
    //     break;
    // }
  }
  public setCompletedFileList(list) {
    // switch (list[0].status) {
    //   case 'removed':
    //     this.completedFileList.pop();
    //     break;
    //   case 'done':
    //     this.completedFileList = list;
    //     break;
    //   default:
    //     break;
    // }
  }
  setFormData(job: any) {
    this.validateForm.reset();
    if (!this.isEmpty(job)) {
      this.validateForm.get('jno').setValue(!this.isEmpty(job.jno) ? job.jno : '');
      this.validateForm.get('jtNo').setValue(!this.isEmpty(job.jtNo) ? job.jtNo : '');
      this.validateForm.get('jlNo').setValue(!this.isEmpty(job.jlNo) ? job.jlNo : '');

      // this.validateForm.get('status').setValue(!this.isEmpty(job.status)?job.status:'');callerName
      this.validateForm.get('callerName').setValue(!this.isEmpty(job.callerName) ? job.callerName : '');
      this.validateForm.get('location').setValue(!this.isEmpty(job.location) ? job.location : '');
      this.validateForm.get('callerPhone').setValue(!this.isEmpty(job.callerPhone) ? job.callerPhone : '');
      this.validateForm.get('hourEstimation').setValue(!this.isEmpty(job.hourEstimation) ? job.hourEstimation : '');
      // tslint:disable-next-line:max-line-length
      this.validateForm.get('estimatedCompletedTime').setValue(!this.isEmpty(job.estimatedCompletedTime) ? new Date(job.estimatedCompletedTime) : null);
      this.validateForm.get('completedRecord').setValue(!this.isEmpty(job.completedRecord) ? job.completedRecord : '');
      this.validateForm.get('completedRecord').setValue(!this.isEmpty(job.completedRecord) ? job.completedRecord : '');
      this.validateForm.get('isEquipment').setValue((job.isEquipment === '0') ? false : true);
      this.validateForm.get('pno').setValue(!this.isEmpty(job.pno) ? job.pno : '');
      this.validateForm.get('taskName').setValue(!this.isEmpty(job.taskName) ? job.taskName : '');
      if (job.isEquipment === '1' && job.epNo != null) {
        this.validateForm.get('epNo').setValue(!this.isEmpty(job.epNo) ? job.epNo : '');
        if (job.equipment != null || job.patrolArea != null) {
          this.validateForm.get('epName').setValue(job.equipment != null ? job.equipment.epName : job.patrolArea.areaName);
          this.validateForm.get('deviceType').setValue(job.equipment != null ? 'equipment' : 'area');
          this.repairApplyType = job.equipment != null ? 'equipment' : 'area';
        } else {
          this.validateForm.get('epName').setValue(null);
          const ls = job.epNo.split('-');
          if (ls[0] === 'region') {
            this.validateForm.get('deviceType').setValue('area');
            this.repairApplyType = 'area';
          } else {
            this.validateForm.get('deviceType').setValue('equipment');
            this.repairApplyType = 'equipment';
          }
        }
        this.equipments = [];
        this.equipments.push({
          value: job.epNo,
          text: job.epNo
        });
      } else {
        this.validateForm.get('deviceType').setValue('other');
        this.repairApplyType = 'other';
      }
      this.validateForm.get('isThirdServices').setValue((job.isThirdServices === '0') ? false : true);
      this.validateForm.get('isAccidentShutdown').setValue((job.isAccidentShutdown === '0') ? false : true);
      this.validateForm.get('mark').setValue(!this.isEmpty(job.mark) ? job.mark : '');
      // this.validateForm.get('verifyDesc').setValue(!this.isEmpty(job.verifyDesc) ? job.verifyDesc : '');
      if (job.verifyDescs !== null && job.verifyDescs.length > 0) {
        let vdesc = '';
        job.verifyDescs.forEach((verifyDesc: any) => {
          vdesc = vdesc + `${verifyDesc.date} ${verifyDesc.name} ${verifyDesc.desc} ${verifyDesc.state} \n`;
        });
        this.validateForm.get('verifyDesc').setValue(vdesc.substring(0, vdesc.length - 1));
      }
      this.validateForm.get('hourCompleted').setValue(!this.isEmpty(job.hourCompleted) ? job.hourCompleted : '');
    }
    // 设置表单禁用项
    if (!this.isEmpty(job)) {
      if ( job.isDuplicate === '1'){
        // 如果为重复工单，设置表单禁用
        this.setFormDisable(5);
      }else{
        // tslint:disable-next-line:radix
        this.setFormDisable(parseInt(this.job.status));
      }
    }
  }
  // 现在修改为从父组件传过来的job对象中已经包含了附件，所以不需要重新去后台请求，注释之前请求获取附件代码
  // async initFileList() {
  //   let attmentFiles = [];
  //   let beforeRecordAttachment = [];
  //   let completedRecordAttachment = [];
  //   // 附件
  //   const attachments = await this.jobService.getJobAttachment(this.job.jno);
  //   if (attachments != null && attachments.length > 0) {
  //     for (const attachment of attachments) {
  //       attmentFiles.push(
  //         {
  //           uid: attachment.id,
  //           status: 'done',
  //           url: 'attachmentServer' + attachment.url
  //         }
  //       );
  //       this.kList.push(
  //         {
  //           uid: attachment.id,
  //           name: '报修图片' + attachment.attachName,
  //           url: 'attachmentServer' + attachment.url,
  //           status: 'done',
  //           showDownload: false,
  //           type: attachment.attachType,
  //           response: { code: 200, data: { url: attachment.url } },
  //           iconType: '',
  //           isImageUrl: false,
  //           isUploading: false,
  //           linkProps: undefined,
  //           message: ''
  //         }
  //       );
  //     }
  //   } else {
  //     attmentFiles = [{
  //       uid: -1,
  //       status: 'done',
  //       url: '/assets/img/web/no-picture.png'
  //     }];
  //   }
  //   this.faultFileList = attmentFiles;
  //   // 维修前附件
  //   const beforeAttachments = await this.jobService.getJobBeforeAttachment(this.job.jno);
  //   if (beforeAttachments != null && beforeAttachments.length > 0) {
  //     for (const attachment of beforeAttachments) {
  //       beforeRecordAttachment.push(
  //         {
  //           uid: attachment.id,
  //           status: 'done',
  //           url: 'attachmentServer' + attachment.url
  //         }
  //       );
  //       this.kList.push(
  //         {
  //           uid: attachment.id,
  //           name: '维修前图片' + attachment.attachName,
  //           url: 'attachmentServer' + attachment.url,
  //           status: 'done',
  //           showDownload: false,
  //           type: attachment.attachType,
  //           response: { code: 200, data: { url: attachment.url } },
  //           iconType: '',
  //           isImageUrl: false,
  //           isUploading: false,
  //           linkProps: undefined,
  //           message: ''
  //         }
  //       );
  //     }
  //   } else {
  //     beforeRecordAttachment = [{
  //       uid: -1,
  //       status: 'done',
  //       url: '/assets/img/web/no-picture.png'
  //     }];
  //   }
  //   this.beforeFileList = beforeRecordAttachment;
  //   // 维修后附件
  //   const completedAttachments = await this.jobService.getJobCompletedAttachment(this.job.jno);
  //   if (completedAttachments != null && completedAttachments.length > 0) {
  //     for (const attachment of completedAttachments) {
  //       completedRecordAttachment.push(
  //         {
  //           uid: attachment.id,
  //           status: 'done',
  //           url: 'attachmentServer' + attachment.url
  //         }
  //       );
  //       this.kList.push(
  //         {
  //           uid: attachment.id,
  //           name: '维修后图片' + attachment.attachName,
  //           url: 'attachmentServer' + attachment.url,
  //           status: 'done',
  //           showDownload: false,
  //           type: attachment.attachType,
  //           response: { code: 200, data: { url: attachment.url } },
  //           iconType: '',
  //           isImageUrl: false,
  //           isUploading: false,
  //           linkProps: undefined,
  //           message: ''
  //         }
  //       );
  //     }
  //   } else {
  //     completedRecordAttachment = [{
  //       uid: -1,
  //       status: 'done',
  //       url: '/assets/img/web/no-picture.png'
  //     }];
  //   }
  //   this.completedFileList = completedRecordAttachment;
  // }
  public setFormDisable(status: number) {
    this.validateForm.controls.jno.disable();
    this.validateForm.controls.pno.disable();
    this.validateForm.controls.taskName.disable();
    // this.validateForm.controls.location.disable();
    this.validateForm.controls.callerName.disable();
    this.validateForm.controls.callerPhone.disable();
    // this.validateForm.controls.isThirdServices.disable();
    this.validateForm.controls.completedRecord.disable();
    // 设置固定资产不可以修改
    // this.validateForm.controls.isEquipment.disable();
    // this.validateForm.controls.epNo.disable();
    this.validateForm.controls.epName.disable();
    this.validateForm.controls.verifyDesc.disable();
    if (this.code === 0 || this.code === 3) {// code 为0 表示详情
      // tslint:disable-next-line:forin
      for (const key in this.validateForm.controls) {
        this.validateForm.controls[key].disable();
      }
    } else if (this.code === 1) { // code 为1 表示编辑
      this.validateForm.controls.jtNo.disable();
    } else {
      this.validateForm.controls.mark.disable();
      switch (status) {
        // case 0:
        //   this.validateForm.controls.jtNo.disable();
        //   break;
        case 1:
          this.validateForm.controls.jtNo.enable();
          break;
        case 2:
          this.validateForm.controls.jtNo.enable();
          break;
        case 3:
          this.validateForm.controls.jtNo.enable();
          break;
        case 4:
          this.validateForm.controls.jtNo.enable();
          break;
        // tslint:disable-next-line:no-switch-case-fall-through
        case 5:
          // tslint:disable-next-line:forin
          for (const key in this.validateForm.controls) {
            this.validateForm.controls[key].disable();
          }
          break;
        default:
          break;
      }
    }
  }
  public validateFormData() {
    // tslint:disable-next-line:forin
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
    return this.validateForm.valid;
  }
  public getValidateForm() {
    return this.validateForm;
  }
  public getJob() {
    // 提交工单时需要设置当前报修类型
    this.repairApplyType = this.validateForm.value.deviceType;
    // tslint:disable-next-line:prefer-const
    let newJob: any = {};
    newJob.jno = this.job.jno;
    newJob.dispatcherNo = this.job.dispatcherNo;
    // tslint:disable-next-line:radix
    if (parseInt(this.job.status) !== 0 && this.code === 2) {
      if (this.job.jtNo !== this.validateForm.value.jtNo) {
        newJob.jtNo = this.validateForm.value.jtNo;
      }
    }
    if (this.job.jlNo !== this.validateForm.value.jlNo) {
      newJob.jlNo = this.validateForm.value.jlNo;
    }
    if (this.job.hourEstimation !== this.validateForm.value.hourEstimation) {
      newJob.hourEstimation = this.validateForm.value.hourEstimation;
    }
    if (this.job.estimatedCompletedTime !== this.validateForm.value.estimatedCompletedTime) {
      newJob.estimatedCompletedTime = moment(this.validateForm.value.estimatedCompletedTime).format('YYYY-MM-DD HH:mm:ss');
    }
    if (this.job.mark !== this.validateForm.value.mark) {
      newJob.mark = this.validateForm.value.mark;
    }
    if (this.job.isThirdServices !== (this.validateForm.value.isThirdServices ? '1' : '0')) {
      newJob.isThirdServices = this.validateForm.value.isThirdServices ? '1' : '0';
    }
    if (this.job.isAccidentShutdown !== (this.validateForm.value.isAccidentShutdown ? '1' : '0')){
      newJob.isAccidentShutdown = this.validateForm.value.isAccidentShutdown ? '1' : '0';
    }
    // if (this.job.isEquipment !== (this.validateForm.value.deviceType !== 'other' ? '1' : '0')){
    //   newJob.isEquipment = this.validateForm.value.deviceType !== 'other' ? '1' : '0';
    // }
    newJob.isEquipment = this.validateForm.value.deviceType !== 'other' ? '1' : '0';
    if (newJob.isEquipment === '1') {
      if (this.job.epNo !== this.validateForm.value.epNo) {
        newJob.epNo = this.validateForm.value.epNo;
      }
    } else {
      newJob.epNo = null;
    }
    if (this.job.location !== this.validateForm.value.location) {
      newJob.location = this.validateForm.value.location;
    }
    return newJob;
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
  public nzmodelChange($event) {
    if (!this.isEmpty($event) && $event.indexOf(':') > 0) {
      const ls = $event.split(':');
      this.equipments = [];
      this.equipments.push({
        value: ls[0],
        text: ls[0]
      });
      this.validateForm.get('epNo').setValue(ls[0]);
      this.validateForm.get('epName').setValue(ls[1]);
      this.validateForm.get('location').setValue(ls[2]);
      // const ls = this.equipments.filter((item) => item.value = $event);
      // if ( ls.length > 0){
      //   this.validateForm.get('epName').setValue(ls[0].text);
      // }
      // const ls = $event.split('&');
      // this.validateForm.get('epName').setValue(ls[1]);
    }
  }
  // 修改报修类型时需要修改equipments
  ngModelChangeType($event) {
    if ($event !== this.repairApplyType) {
      this.equipments = [];
      this.validateForm.get('epNo').setValue(null);
      this.validateForm.get('epName').setValue(null);
    }
    if ($event === 'area' || $event === 'equipment') {
      this.validateForm.get('epNo').setValidators(Validators.required);
    } else {
      this.validateForm.get('epNo').clearValidators();
    }
    // this.repairApplyType = $event;
    // this.equipments = [];
    // this.validateForm.get('epNo').setValue(null);
    // this.validateForm.get('epName').setValue(null);
  }
  /**
   * 
   * 生成知识点
   */
  createKnowledge() {
    // const list = [];
    // list.push(this.faultFileList);
    // list.push(this.beforeFileList);
    // list.push(this.completedFileList);
    //   + this.beforeFileList + this.completedFileList;
    const modals = this.modal.create({
      nzTitle: '创建-新知识',
      nzContent: KnowledgeDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 800,
      nzFooter: null,
      nzMaskClosable: false,
      nzComponentParams: {
        knowledgeTypes: this.knowledgeTypes,
        kno: null,
        jobInfo: {
          name: this.job.typeName + '工单知识点',
          zrr: this.job.repairerName,
          desc: this.validateForm.get('completedRecord').value,
          fileList: this.kList
        }
      }
    });
    modals.afterClose.subscribe(
      {
        next: num => {
          if (num === 'success') {
            // this.msg.create('success', '创建知识点成功!');
          }
        }
      }
    );
  }
  /**
   * 查询知识类型数据
   */
  async initTypeData() {
    const result = await this.dataService.queryKnowledgeType();
    if (result.code !== 200) {
      this.msg.create('error', result.msg);
      return;
    }
    for (const data of result.data) {
      const node = {
        title: data.ktName,
        value: data.ktId,
        key: data.ktId
      };
      this.knowledgeTypes.push(node);
    }
  }
  search(value: string): void {
    if (!this.isEmpty(value)) {
      if (this.validateForm.get('deviceType').value === 'area') {
        this.areaService.getAreasByFilterString(value)
          .subscribe(data => {
            const listOfOption: Array<{ value: string, text: string }> = [];
            data.forEach(item => {
              listOfOption.push({
                value: item.areaNo + ':' + item.areaName + ':' + item.location,
                text: item.areaNo + ':' + item.areaName
              });
            });
            this.equipments = [];
            this.equipments = listOfOption;
          });
      }
      if (this.validateForm.get('deviceType').value === 'equipment') {
        this.equipmentService.
          getEquipmentsByFilterString(value)
          .subscribe(data => {
            const listOfOption: Array<{ value: string, text: string }> = [];
            data.forEach(item => {
              listOfOption.push({
                value: item.epNo + ':' + item.epName + ':' + (this.isEmpty(item.storeLocation) ? '' : item.storeLocation),
                text: item.epNo + ':' + item.epName
              });
            });
            this.equipments = [];
            this.equipments = listOfOption;
          });
      }
    }
  }
  disabledDate(time: any) {
    return time.getTime() < Date.now() - 8.64e7;
  }
  thirdServiceCheckBoxChanged(ev){
    // if (ev !== null){
    //   this.nzThirdServiceChangedVote.emit(ev);
    // }
  }
  // 显示巡检表单弹框
  showModal(group) {
    const modal = this.modalService.create({
      nzTitle: group.groupType === '1' ? '巡检组-' + group.groupName : '固定资产组-' + group.groupName,
      nzContent: JobPatrolSheetComponent,
      nzStyle: { top: '20px' },
      nzWidth: 700,
      nzComponentParams: {
        groupId: group.groupId,
        formDisabled: true,
        jobId: this.job.jno
      },
      nzOkText: '关闭',
      nzCancelText: null,
      nzOnOk: (ev) => {
      }
    });
  }
  parseNumber(status: string ){
    return Number(status);
  }
}
